export default __webpack_public_path__ + "static/media/overwhelm1.d8c39c5c.png";